import {
  validateMonthMembership,
  type MonthValidationResult
} from "@/features/profit-calculators/calculator-shared/utils/monthValidation"
import { getAmazonMonthLabel } from "@/features/profit-calculators/amazon-calculator/utils/amazonReports"

const getValidAmazonMonthLabel = (dateStr: string): string | null => {
  const label = getAmazonMonthLabel(dateStr)
  return label === "Unknown Month" ? null : label
}

/** Validates Amazon order dates against the selected report month. */
const validateAmazonMonth = (
  purchaseDates: string[],
  targetMonthLabel: string,
  thresholdPct?: number
): MonthValidationResult =>
  validateMonthMembership(purchaseDates, targetMonthLabel, getValidAmazonMonthLabel, thresholdPct)

/** Validates the date/time rows in an Amazon Custom Unified Transaction CSV. */
const validateAmazonTransactionMonth = (
  transactionDates: string[],
  targetMonthLabel: string
): MonthValidationResult => {
  const validation = validateMonthMembership(
    transactionDates,
    targetMonthLabel,
    getValidAmazonMonthLabel,
    Number.EPSILON
  )

  if (validation.valid) return validation
  if (validation.detectedMonths.length === 0) {
    return {
      ...validation,
      reason: `No valid transaction dates were found. Please upload the ${targetMonthLabel} transaction CSV.`
    }
  }

  return {
    ...validation,
    reason: `This transaction CSV contains ${validation.detectedMonths[0].label} data. Please upload the ${targetMonthLabel} transaction CSV.`
  }
}

export { validateAmazonMonth, validateAmazonTransactionMonth }
